"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialAddressesState = void 0;
exports.initialAddressesState = {
    addresses: Array(),
};
